import { PixelCrop } from 'react-image-crop'

export function readImageFile(file: Blob): Promise<{ imageDataUrl: string; width: number } | null> {
  return new Promise(resolve => {
    const reader = new FileReader()

    reader.addEventListener('load', () => {
      const image = new Image()
      if (typeof reader.result === 'string') {
        const result = reader.result
        image.src = reader.result
        image.addEventListener('load', () =>
          resolve({
            imageDataUrl: result,
            width: image.width
          })
        )
      } else {
        null
      }
    })

    reader.readAsDataURL(file)
  })
}

export const createImage = (url: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const image = new Image()
    image.addEventListener('load', () => resolve(image))
    image.addEventListener('error', error => reject(error))
    image.src = url
    image.crossOrigin = 'use-credentials'
  })

export const getCroppedImg = async (file: File, pixelCrop: PixelCrop, imageDimensions: { width: number; height: number }): Promise<Blob | null> => {
  const url = URL.createObjectURL(file)
  const image = await createImage(url)

  const canvas = document.createElement('canvas')
  const scaleX = image.naturalWidth / imageDimensions.width
  const scaleY = image.naturalHeight / imageDimensions.height

  canvas.width = pixelCrop.width
  canvas.height = pixelCrop.height

  const ctx = canvas.getContext('2d')

  if (!ctx) {
    throw new Error('No 2d context')
  }

  ctx.imageSmoothingQuality = 'high'

  ctx.save()

  ctx.drawImage(image, pixelCrop.x * scaleX, pixelCrop.y * scaleY, pixelCrop.width * scaleX, pixelCrop.height * scaleY, 0, 0, pixelCrop.width, pixelCrop.height)

  ctx.restore()

  // As a blob
  return new Promise(resolve => {
    canvas.toBlob(f => {
      resolve(f)
    }, 'image/jpeg')
  })
}
